export default __webpack_public_path__ + "static/media/easy-projects-logo.4283f001.svg";